// import components
import { styled, Box, Button } from '@mui/material';

export const StyledSortedFieldsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.25)
}));

export const StyledRoundModalBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const StyledRoundModalButton = styled(Button)(() => ({
  display: 'flex',
  marginLeft: 'auto'
}));
